module.exports = __webpack_public_path__ + "img/ACU.3c70bbfb.png";